import { Inter } from 'next/font/google';

// Single Inter instance shared by _app (className/variable) and the Material-UI
// theme, so both the Tailwind and the MUI widgets render with the same family.
export const inter = Inter({
  weight: ['300', '400', '500', '600', '700'],
  display: 'swap',
  subsets: ['latin', 'latin-ext'],
  variable: '--font-sans'
});

// NOTE: multi-word families must stay quoted, otherwise the whole CSS
// font-family declaration is invalid and the browser falls back to Times.
export const fontStack = [
  inter.style.fontFamily,
  '-apple-system',
  '"Segoe UI"',
  'Helvetica',
  'Arial',
  'sans-serif'
].join(', ');

export default inter;
